import * as React from "react";
import { useCallback, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "components/common";
import useElementDimensions from "hooks/useElementDimensions";
import { Path, PathNavWrapper, PathScrollContainer } from "../styledComponents";
const SCROLL_STEP_PX = 120;
const PathNav = ({ repo, repoPath, setRepoPath, setRepo }) => {
  const { t } = useTranslation("enterprise_security_sigma");
  const scrollRef = useRef(null);
  const { width } = useElementDimensions(scrollRef);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const updateScrollState = useCallback(() => {
    const el = scrollRef.current;
    if (!el) {
      return;
    }
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth);
  }, []);
  useLayoutEffect(() => {
    updateScrollState();
  }, [updateScrollState, repo, repoPath, width]);
  const handleScrollLeftClick = () => {
    var _a;
    (_a = scrollRef.current) == null ? void 0 : _a.scrollBy({ left: -SCROLL_STEP_PX, behavior: "smooth" });
  };
  const handleScrollRightClick = () => {
    var _a;
    (_a = scrollRef.current) == null ? void 0 : _a.scrollBy({ left: SCROLL_STEP_PX, behavior: "smooth" });
  };
  const backToRepoList = () => {
    setRepo(null);
    setRepoPath("");
  };
  const changePath = (inPath) => () => {
    if (inPath === "/") {
      setRepoPath("");
    }
    let pathArray = repoPath.split("/");
    const pathIdx = pathArray.indexOf(inPath);
    pathArray = pathArray.slice(0, pathIdx + 1);
    setRepoPath(pathArray.length === 0 ? "" : pathArray.join("/"));
  };
  return /* @__PURE__ */ React.createElement(PathNavWrapper, null, /* @__PURE__ */ React.createElement(PathScrollContainer, { ref: scrollRef, onScroll: updateScrollState }, /* @__PURE__ */ React.createElement(Path, { onClick: backToRepoList }, t("path_nav.repo_list")), repo && repoPath.split("/").map((path) => /* @__PURE__ */ React.createElement(Path, { "data-testid": path, key: path, onClick: changePath(path) }, path || t("path_nav.root"), "/"))), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: "chevron_left",
      title: t("path_nav.scroll_left"),
      size: "xsmall",
      disabled: !canScrollLeft,
      onClick: handleScrollLeftClick
    }
  ), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: "chevron_right",
      title: t("path_nav.scroll_right"),
      size: "xsmall",
      disabled: !canScrollRight,
      onClick: handleScrollRightClick
    }
  ));
};
export default PathNav;
